export default "__VITE_ASSET__Gn7q29$j__"